import { api } from './client'

export interface User {
  id: string
  email: string
  name: string | null
  is_vn2r_admin: boolean
}

export interface Workspace {
  id: string
  organization_id: string
  slug: string
  name: string
  archived_at: string | null
  /** Contexto pessoal de um convidado: sem módulos, só com o que lhe
   *  partilharam (ver docs/PARTILHA.md). */
  convidado?: boolean
}

export interface MeResponse {
  user: User
  workspace: Workspace
  modules: string[]
  has_password: boolean
  /** Recursos partilhados com a pessoa a partir de outros workspaces,
   *  por tipo ('modelo', 'bcf', 'triagem'). */
  partilhados?: Partial<Record<'modelo' | 'bcf' | 'triagem', number>>
}

export interface PasswordStatus {
  has_password: boolean
}

export const authApi = {
  me: () => api.get<MeResponse>('/api/auth/me'),
  /** Com o workspace em branco, o servidor procura a conta de convidado
   *  da pessoa. */
  requestMagicLink: (email: string, workspaceSlug: string) =>
    api.post<void>('/api/auth/request', {
      email,
      workspace_slug: workspaceSlug,
    }),
  loginWithPassword: (
    email: string,
    workspaceSlug: string,
    password: string,
    force = false,
  ) =>
    api.post<void>('/api/auth/login', {
      email,
      workspace_slug: workspaceSlug,
      password,
      force,
    }),
  passwordStatus: () =>
    api.get<PasswordStatus>('/api/auth/password-status'),
  setPassword: (newPassword: string, currentPassword: string | null) =>
    api.post<void>('/api/auth/set-password', {
      new_password: newPassword,
      current_password: currentPassword,
    }),
  logout: () => api.post<void>('/api/auth/logout'),
}
